<template>
  <b-modal
    :title="$ml.get('titleModalBackup2fa')"
    id="backup-2fa-modal"
    :visible="value"
    @hide="closeModal"
    hide-footer
    centered
    size="md"
  >
    <div class="col-24 d-flex justify-content-center">
      <div class="form-group col-16">
        <label class="text-muted" v-text="$ml.get('useCodeEmail')"
          >Use o código recebido por email</label
        >
        <the-mask
          class="form-control"
          v-model="codeEmail"
          :mask="['### ###']"
          @input="updateCodeEmail"
          :placeholder="$ml.get('enterTheCode')"
        />
        <div
          class="col-24"
          :style="[
            { display: errorCodeEmail ? 'flex' : '' },
            {
              'justify-content': errorCodeEmail ? 'space-between ' : '',
            },
            {
              'flex-wrap': errorCodeEmail ? 'wrap' : '',
            },
          ]"
        >
          <transition name="fade">
            <label
              v-if="errorCodeEmail"
              style="position: relative; !important"
              class="lblError px-0"
              v-text="$ml.get('invalidCodeError')"
            >
              O código informado não é válido!
            </label>
          </transition>
          <label
            v-if="!errorAwaitNewRequest"
            style="
              color: #730ba9;
              cursor: pointer;
              font-size: 12px;
              white-space: nowrap;
            "
            @click="sendCodeEmail"
            >{{
              timeLeftEmail > 0
                ? `${$ml.get("requestNewCodeEmail")} ${formattedTimeEmail}`
                : $ml.get("receiveCode")
            }}</label
          >
          <label v-else-if="errorAwaitNewRequest && !errorCodeEmail" class="lblError" v-text="$ml.get('awaitNewToken')">Aguarde! Em breve, você poderá solicitar um novo token.</label>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-group col-16">
        <label class="text-muted" v-text="$ml.get('enterTheCodeBackup')"
          >Insira seu código de backup</label
        >
        <input
          v-model="codeInput"
          autocapitalize="off"
          class="form-control"
          :placeholder="$ml.get('enterTheCode')"
          type="text"
          @input="updateCodeInput"
        />
        <transition name="fade">
          <label
            v-if="errorCodeBackup"
            style="position: relative; !important"
            class="lblError px-0"
            v-text="$ml.get('invalidCodeError')"
          >
            O código informado não é válido!
          </label>
        </transition>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <RecaptchaV2
        ref="recaptcha"
        @verify="setRecaptchaToken"
        @expired="tokenRecaptcha = ''"
      />
    </div>

    <div class="swal2-actions">
      <button
        type="button"
        class="swal2-confirm swal2-styled btn"
        @click="sendRequest"
        :disabled="!tokenRecaptcha || !codeEmail || !codeInput"
      >
        {{ $ml.get("toCheck") }}
      </button>
      <button
        type="button"
        class="swal2-cancel swal2-styled"
        @click="closeModal"
      >
        {{ $ml.get("cancel") }}
      </button>
    </div>
  </b-modal>
</template>
<script>
import Swal from "sweetalert2";
import RecaptchaV2 from "../../components/recaptchaV2.vue";
import AccountService from "../../services/account.service";
export default {
  name: "ModalBackup2fa",
  components: {
    RecaptchaV2,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      tokenRecaptcha: "",
      formattedTimeEmail: "",
      timeLeftEmail: 0,
      
      codeInput: "",
      codeEmail: "",
      errorCodeEmail: false,
      errorCodeBackup: false,
      errorAwaitNewRequest: false,
    };
  },
  watch: {
    errorCodeBackup() {
      if (this.errorCodeBackup) {
        this.$refs.recaptcha.resetRecaptcha();
      }
    },
    errorCodeEmail() {
      if (this.errorCodeEmail) {
        this.$refs.recaptcha.resetRecaptcha();
      }
    },
  },
  mounted() {
    this.codeEmail = "";
  },
  methods: {
    
    setRecaptchaToken(token) {
      this.$emit("update:setRecaptchaToken", token);
      this.tokenRecaptcha = token;
    },
    updateCodeInput() {
      this.errorCodeBackup = false;
      this.$emit("update:codeInput", this.codeInput);
    },
    sendRequest() {
      this.$emit("sendRequest");
    },
    updateCodeEmail() {
      this.$emit("update:codeEmail", this.codeEmail);
      this.errorCodeEmail = false;
    },
    async sendCodeEmail() {
      if (this.timeLeftEmail > 0) return;

      const newCodeRequest = 300;
      this.timeLeftEmail = newCodeRequest;

      const interval = setInterval(() => {
        if (this.timeLeftEmail > 0) {
          this.timeLeftEmail--;

          const minutes = Math.floor(this.timeLeftEmail / 60);
          const seconds = this.timeLeftEmail % 60;

          this.formattedTimeEmail = `${minutes}:${seconds
            .toString()
            .padStart(2, "0")}`;
        } else {
          clearInterval(interval);
          this.errorAwaitNewRequest = false;
        }
      }, 1000);

      try {
        const { status } = await AccountService.getExtTokenEmail({
          email: this.user,
        });

        if (status === 200) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("sendToken"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        console.log(error.response);
        this.errorAwaitNewRequest = true;
      }
    },

    closeModal() {
      this.$emit("input", false);
      this.tokenRecaptcha = "";
      this.timeLeftEmail = 0;

      this.errorCodeEmail = false;
      this.errorCodeBackup = false;
      this.errorAwaitNewRequest = false;

      this.codeEmail = "";
      this.codeInput = "";
    },
  },
};
</script>

<style>
.modal-header {
  border-bottom: none !important;
}
.modal-content {
  border: none !important;
  border-radius: 5px !important;
}

</style>
